
import { Component, Vue, Prop } from 'vue-property-decorator';
import Masthead from './Common/Masthead.vue';

// :image="image || { source: '/assets/images/home/masthead', formats: ['avif', 'webp', 'jpg'], fallback: 'jpg' }"

@Component({
  components: {
    Masthead,
  },
})
export default class SiteMasthead extends Vue {
  @Prop()
  private readonly mini!: boolean;

  @Prop()
  private readonly title!: string;

  @Prop()
  private readonly subtitle!: string;

  @Prop()
  private readonly image!: string;

  @Prop()
  private readonly darken!: boolean;

  @Prop()
  private readonly height!: string;

  @Prop({ default: false })
  private readonly relativeContent!: boolean;
}
